import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-commerce',
  templateUrl: './dialog-commerce.component.html',
  styleUrls: ['./dialog-commerce.component.scss']
})
export class DialogCommerceComponent {
  confirmation: boolean;

  constructor(private dialogRef: MatDialogRef<DialogCommerceComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.confirmation = data.confirmation;
  }

  close() {
    this.dialogRef.close();
  }

  resDialog() {
    if (this.confirmation) {
      return this.dialogRef.close(true);
    }
    return false;
  }
}
